import React from "react";

import { DropdownMenuItem } from "src/app/components/Dropdown/Dropdown";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as DeleteIcon } from "src/images/trash-can.svg";

export default function RemoveMenuItem({
  handleClick,
}: {
  handleClick: () => void;
}) {
  return (
    <DropdownMenuItem
      className="dropdown__menu-item--danger"
      onClick={handleClick}
    >
      <DeleteIcon />
      <IDHFormattedMessage id="ws_remove" defaultMessage="Remove" />
    </DropdownMenuItem>
  );
}
